
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.34 1.977v4.8h4.8M17.94 1.176l-5.6 5.6M17.14 13.914v2.4a1.6 1.6 0 01-1.745 1.6 15.839 15.839 0 01-6.904-2.452 15.593 15.593 0 01-4.8-4.8A15.852 15.852 0 011.235 3.72a1.6 1.6 0 011.593-1.744h2.4a1.6 1.6 0 011.6 1.376c.101.769.29 1.524.56 2.25a1.6 1.6 0 01-.36 1.689L6.011 8.305a12.8 12.8 0 004.8 4.8l1.013-1.016a1.6 1.6 0 011.688-.36c.726.27 1.48.459 2.248.56.806.113 1.4.812 1.38 1.625z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    